import React, { createContext, useContext, useMemo } from 'react';

const DashboardScrollContext = createContext(null);

export const DashboardScrollProvider = ({ children, scrollContainerRef }) => {
  const value = useMemo(
    () => ({ scrollContainerRef }),
    [scrollContainerRef]
  );
  return (
    <DashboardScrollContext.Provider value={value}>
      {children}
    </DashboardScrollContext.Provider>
  );
};

export const useDashboardScroll = () => {
  const context = useContext(DashboardScrollContext);
  return context?.scrollContainerRef ?? null;
};
